<template>
  <div class="onboarding-container pa-3 ma-1">
    <v-row><v-col align="center">
    <div class="welcome-message">
      <h1 class="main_pink--text mb-2">{{$t('generics.hello')}} {{ auth.name }}</h1>
      <p>{{ $t('pages.popup.nice_to_see_you') }}</p>
    </div>
    <form @submit.prevent="onSubmit" class="onboarding-form pa-3">
      <label for="email">{{$t('pages.popup.get_news_and_updates')}}</label>
      <input
          type="email"
          v-model="form.optional_email"
          id="email"
          :placeholder="$t('pages.popup.email')"
          required
          class="rounded-md pa-2"
      />
      <input
          type="tel"
          v-model="form.phone"
          id="phone"
          :placeholder="$t('pages.popup.phone')"
          required
          class="rounded-md pa-2"
      />
      <v-btn type="submit" rounded-md color="secondary" >{{$t('pages.popup.continue')}}</v-btn>
    </form>

    <p class="privacy-note">{{$t('pages.popup.unsubscribe_anytime')}}</p>
    </v-col></v-row>
  </div>
</template>


<script>
import FormView from "src/mixins/FormView";
import UserModule from "src/store/modules/User.module"

export default {
  name: "WelcomeDetails",
  mixins: [new FormView(UserModule, "auth")],
  data() {
    return {
      form: {
        optional_email: '',
        phone: ""
      }
    };
  },
  computed: {
    auth() {
      return this.$store.state.AuthModule.user;
    }
  },
  methods: {

    beforeSubmit(formData) {
      formData.id = this.$store.state.AuthModule.user.id
      return formData;
    },
    onSuccess() {
      this.$emit('submit');
    }
  },
};
</script>

<style scoped>

.welcome-message h1 {
  font-size: 24px;
}

.welcome-message p {
  font-size: 16px;
  color: #555;
}

.onboarding-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
}

.onboarding-form label {
  font-size: 14px;
  color: #333;
}

.onboarding-form input {
  font-size: 16px;
  border: 1px solid #ccc;
}

.onboarding-form input {
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
}


.privacy-note {
  font-size: 12px;
  color: #888;
  margin-top: 15px;
}
</style>
